import { AppFunctionComponent } from "../../types"
import React, { useContext } from "react"
import { Quote as QuoteProps } from "../../types"
import { Article } from "../../components/common/general-styles.component"
import RichText from "../rich-text/rich-text.resolver"
import { FootnoteContext } from "../../templates/page.template"

const ArticleListResolver: AppFunctionComponent<QuoteProps> = ({
  text,
  className,
}) => {
  const footnotesOptions = useContext(FootnoteContext)

  return (
    <Article className={className}>
      {text && <RichText content={text} options={footnotesOptions} />}
    </Article>
  )
}

export default ArticleListResolver
